import { render, staticRenderFns } from "./u-btn-arrow-outlined-rounded.vue?vue&type=template&id=1f047066&scoped=true&"
import script from "./u-btn-arrow-outlined-rounded.vue?vue&type=script&lang=js&"
export * from "./u-btn-arrow-outlined-rounded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f047066",
  null
  
)

export default component.exports